import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-va',
  templateUrl: './payment-va.component.html',
  styleUrl: './payment-va.component.scss'
})
export class PaymentVaComponent {

}
